import { BagCarryOnOffIcon } from './BagCarryOnOffIcon';

/**
 * author: Google
 * id F11D5411-E08A-483D-B04C-A75B523C717C
 * name bag-carry-on-off
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bag-carry-on-off.svg
 * tags
 * - Transportation + Flying 
 */
export const CarryOnLuggageOffIcon = BagCarryOnOffIcon;
export default CarryOnLuggageOffIcon